const cmId = import.meta.env.VITE_TRUSTARC_CM_ID;

export const initTrustArc = () => {
  if (!cmId) {
    return;
  }

  const trustArcScript = document.createElement('script');
  trustArcScript.setAttribute('src', `https://consent.trustarc.com/v2/notice/${cmId}`);
  document.body.append(trustArcScript);
};

// Listen for TrustArc consent changes
window.addEventListener('trustarc-consent-updated', () => {
  window.dispatchEvent(new CustomEvent('jrny-consent-updated'));
});

window.addEventListener('trustarc-ccm-ready', () => {
  window.dispatchEvent(new CustomEvent('trustarc-ready'));
});
